/**
 * GetPremiumPackagesUseCase
 *
 * Loads premium package catalog from local SecureStorage.
 * Data is populated by syncSecureStorageUseCase during sync.
 */
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { PremiumPackageStorage } from '@/domain/entities/secureStorage/secureStorageEntities';
import type { PremiumPackageEntity } from '@/domain/entities/premiumPackage/premiumPackageEntity';
import { PremiumPackageRemapper } from '@/domain/remappers/premiumPackage/premiumPackageRemapper';

export class GetPremiumPackagesUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage ?? SecureStorageWebCrypto.getInstance();
  }

  async execute(): Promise<PremiumPackageEntity[]> {
    const storageItems = await this.storage.getAllWithPrefix<PremiumPackageStorage>(
      SECURE_STORAGE_KEYS.PREMIUM_PACKAGES
    );

    const entities = PremiumPackageRemapper.fromStorageList(storageItems);
    entities.sort((a, b) => a.order - b.order);

    return entities;
  }
}

export const createGetPremiumPackagesUseCase = (): GetPremiumPackagesUseCase => {
  return new GetPremiumPackagesUseCase();
};
